module.exports = __webpack_public_path__ + "media/images/note-vault-31dab57e03ebfcf2b076fa1ff15072cb.jpg";